import React from 'react';
import PropTypes from "prop-types";

const Modal = ({ isVisible, onClose, children }) => {
    if(!isVisible) {
        return null;
    }

    return (
        <div className="modal-container">
            <div className="modal-content">
                <button className="normal-button modal-close-button" onClick={onClose}>
                    <i className="ri-close-line custom-close-icon"></i>
                </button>
                {children}
            </div>
        </div>
    )
}

export default Modal;

Modal.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.object])
}